module.exports = __webpack_public_path__ + "static/banner-keyman-2@3x-1fb55c0b9b9d1c13fa4aa9bf1aa86ddb.png";